import React, { useRef, useState, useEffect } from 'react';

export const PinInput = ({ length = 4, onComplete, disabled = false, autoFocus = true }) => {
    const [values, setValues] = useState(Array(length).fill(''));
    const inputRefs = useRef([]);

    useEffect(() => {
        if (autoFocus && inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, [autoFocus]);

    const handleChange = (index, value) => {
        if (!/^\d*$/.test(value)) return;
        
        const newValues = [...values];
        newValues[index] = value.slice(-1);
        setValues(newValues);

        // Move to next input
        if (value && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
        }

        // Check if complete - use setTimeout to ensure state is updated
        const allFilled = newValues.every(v => v !== '');
        if (allFilled) {
            const pin = newValues.join('');
            setTimeout(() => {
                onComplete?.(pin);
            }, 100);
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !values[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, length);
        if (!/^\d+$/.test(pastedData)) return;

        const newValues = [...values];
        pastedData.split('').forEach((char, i) => {
            if (i < length) newValues[i] = char;
        });
        setValues(newValues);

        if (pastedData.length === length) {
            onComplete?.(pastedData);
        }
    };

    const reset = () => {
        setValues(Array(length).fill(''));
        inputRefs.current[0]?.focus();
    };

    return (
        <div className="pin-input-group">
            {Array(length).fill(0).map((_, index) => (
                <input
                    key={index}
                    ref={el => inputRefs.current[index] = el}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    value={values[index]}
                    onChange={e => handleChange(index, e.target.value)}
                    onKeyDown={e => handleKeyDown(index, e)}
                    onPaste={handlePaste}
                    disabled={disabled}
                    className="pin-input"
                    autoComplete="off"
                    data-testid={`pin-input-${index}`}
                />
            ))}
        </div>
    );
};

export default PinInput;
